(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beforeafter"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sliderContainers = document.querySelectorAll('[data-slider-container]');
  
  sliderContainers.forEach(container => {
    const slider = container.querySelector('[data-slider]');
    const afterImage = container.querySelector('[data-after-image]');
    let isDragging = false;
    
    function updateSlider(x) {
      const rect = container.getBoundingClientRect();
      const percentage = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
      
      slider.style.left = percentage + '%';
      afterImage.style.clipPath = `inset(0 0 0 ${percentage}%)`;
    }
    
    function startDragging(e) {
      isDragging = true;
      container.style.cursor = 'ew-resize';
    }
    
    function stopDragging() {
      isDragging = false;
      container.style.cursor = 'default';
    }
    
    function onMove(e) {
      if (!isDragging) return;
      
      const x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      updateSlider(x);
    }
    
    slider.addEventListener('mousedown', startDragging);
    slider.addEventListener('touchstart', startDragging);
    
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove);
    
    document.addEventListener('mouseup', stopDragging);
    document.addEventListener('touchend', stopDragging);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
